import React from "react";
import { withRouter } from "react-router-dom";
import * as S from "../planos/styles";
import Logo from "../../assets/logo-agroreceita-black.svg";
import Footer from "../../components/footer";
import PoliticaPrivacidadeTexto from "../../components/legal/politicaPrivacidadeTexto";
import maintainUtm from "../../services/maintainUtm";
import { getCurrentPageIdWithDevice } from "../../services/maintainUtm/idPages";

const PoliticaPrivacidadePage = (props) => {
    const colors = {
        primary: "#22C55E",
        text: "#21262F",
        bg: "#FFFFFF",
    };

    const styles = {
        page: { display: 'flex', flexDirection: 'column', alignItems: 'center', background: colors.bg, color: colors.text, minHeight: "100vh" },
        container: { maxWidth: 1080, margin: "0 auto", padding: "48px 24px" },
        header: { marginBottom: 24 },
        title: { fontSize: 36, fontWeight: 800, margin: 0 },
    };

    const redirectLogin = () => {
        const current = new URL(window.location.href);
        props.history.push({ pathname: "/login", search: current.search });
    };

    const redirectCadastro = () => {
        const currentPageId = getCurrentPageIdWithDevice();
        const search = maintainUtm(`${currentPageId}-headertestegratis`);
        props.history.push({ pathname: '/cadastro', search: search });
    };

    return (
        <div style={styles.page}>

            <S.HeaderPlans style={{ marginBottom: 48, marginTop: 24 }}>
                <div class="image">
                    <a href="https://agroreceita.com.br/">
                        <img src={Logo} alt="Logo AgroReceita" />
                    </a>
                </div>

                <div class="links">
                    <a href="https://agroreceita.com.br/ajuda/">Ajuda</a>
                    <a href="/planos">Planos</a>
                    <a href="https://agroreceita.com.br/blog/">Blog</a>
                </div>

                <div class="buttons-plans">
                    <button onClick={() => redirectLogin()}>Entrar</button>
                    <button onClick={() => redirectCadastro()}>Teste Grátis</button>
                </div>

                <div class="mobile-only">
                    <a href="https://agroreceita.com.br/ajuda/">Ajuda</a>
                    <a onClick={() => redirectLogin()}>Entrar</a>
                </div>
            </S.HeaderPlans>

            <main style={styles.container}>
                <header style={styles.header}>
                    <h1 style={styles.title}>Política de Privacidade</h1>
                </header>

                <PoliticaPrivacidadeTexto />
            </main>

            <footer style={{ width: '100%', padding: "30px 40px", paddingTop: 0 }}>
                <Footer />
            </footer>
        </div>
    );
};

export default withRouter(PoliticaPrivacidadePage);
